import { BaseMutations } from '@/store/base-mutations';
import { Reports } from '@/modules/reports/types';
import { default_date } from '@/modules/reports/services';
import { Organizations } from '@/modules/organizations/types';
import ReportsRepairsState from './state';
import Organization = Organizations.Organization;

export default class ReportsRepairsMutations extends BaseMutations<ReportsRepairsState> {
  SET_REPORTS_DATES(dates: Reports.RepairsDate) {
    this.state.reports_dates = dates;
  }

  UPD_REPORT_DATE({ key, value }: { key: keyof Reports.RepairsPayload, value: unknown }) {
    this.state.report_request_date[key] = value;
  }

  SET_REPORTS(reports: Reports.Repair[]) {
    this.state.reports_list = reports;
  }

  SET_ORGANIZATION(organization: Organization) {
    this.state.organization_id = organization.id as number;
    this.state.organization_name = organization.name_organization;
  }

  CLEAR_DATE() {
    this.state.report_request_date = default_date();
  }
}
